/**
 * Price Box Timer Component
 * Handles countdown timer for product price box
 */
class PriceTimer extends HTMLElement {
  /** @type {number | null} */
  #intervalId = null;

  connectedCallback() {
    const countdownElement = this.querySelector('.price-box__timer-countdown');
    if (!countdownElement) {
      console.warn('Price timer: countdown element not found');
      return;
    }

    // Get the timer end date from the price-timer element's data attribute
    const timerEndDate = this.getAttribute('data-timer-end-date');
    
    let endTime;
    if (!timerEndDate || timerEndDate === '') {
      // If no end date, use a default 24 hours from now
      endTime = Date.now() + 24 * 60 * 60 * 1000;
    } else {
      endTime = new Date(timerEndDate).getTime();
      if (isNaN(endTime)) {
        console.warn('Price timer: invalid end date, using default 24 hours');
        endTime = Date.now() + 24 * 60 * 60 * 1000;
      }
    }

    this.startCountdown(countdownElement, endTime);
  }

  startCountdown(element, endTime) {
    const updateTimer = () => {
      const now = Date.now();
      const distance = endTime - now;

      if (distance < 0) {
        element.textContent = 'Offer expired';
        if (this.#intervalId) {
          clearInterval(this.#intervalId);
          this.#intervalId = null;
        }
        return;
      }

      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      element.textContent = `${hours} hr : ${minutes.toString().padStart(2, '0')} min : ${seconds.toString().padStart(2, '0')} sec`;
    };

    // Update immediately
    updateTimer();

    // Then update every second
    this.#intervalId = setInterval(updateTimer, 1000);
  }

  disconnectedCallback() {
    if (this.#intervalId) {
      clearInterval(this.#intervalId);
      this.#intervalId = null;
    }
  }
}

if (!customElements.get('price-timer')) {
  customElements.define('price-timer', PriceTimer);
}

